export const ENTER: number = 13;
export const ESCAPE: number = 27;
export const SPACE: number = 32;
export const DOWN_ARROW: number = 40;
export const UP_ARROW: number = 38;
export const TAB: number = 9;
